import axiosInstance from '../configs/axios/interceptors';

const CommonServices = {

    getCurrentUser: async (currentUserId) => {
        const params = { id: currentUserId };
        const response = await axiosInstance.get('User/GetUserDetails');
        return response.data;
    },

    getMenus: async (userId) => {
        const params = { userID: userId };
        const response = await axiosInstance.get('Menu/GetMenuList', { params: params });
        return response.data;
    },

    getDocumentCategories: async () => {
        const response = await axiosInstance.get('DocumentCategory/GetDocumentCategories');
        return response.data;
    },

    updateDocCategory: async (payload) => {
        const response = await axiosInstance.put('User/UpdateLastSelectedCategory', payload, { params: payload });
        return response.data;
    },

    getRegions: async () => {
        const response = await axiosInstance.get('DocumentCategory/GetRegions');
        return response.data;
    },


    getCompanies: async () => {
        const response = await axiosInstance.get('DocumentCategory/GetCompanies');
        return response.data;
    },

    getIntervetionTypes: async () => {
        const response = await axiosInstance.get('DocumentCategory/GetInterventionTypes');
        return response.data;
    },


};

export default CommonServices;
